import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import { MembershipType } from '../../core/_models'

type Props = {
  column: ColumnInstance<MembershipType>
}

const MembershipTypeHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {MembershipTypeHeaderColumn}
